import { Component, input, InputSignal, linkedSignal, output, OutputEmitterRef, WritableSignal } from '@angular/core';
import { UiTextareaEditorComponent } from '@app/shared/ui/textarea-editor/ui-textarea-editor.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-file-description',
  templateUrl: './file-description.component.html',
  imports: [TranslatePipe, UiTextareaEditorComponent]
})
export class FileDescriptionComponent {
  protected readonly MAX_DESCRIPTION_LENGTH: number = 50;
  protected readonly isEditing: WritableSignal<boolean> = linkedSignal({
    source: () => this.fileId(),
    computation: () => false
  });

  public readonly description: InputSignal<string | null | undefined> = input.required<string | null | undefined>();
  /** Set where one instance shows many files in turn: a change closes the editor so a draft cannot reach another file. */
  public readonly fileId: InputSignal<string | undefined> = input<string | undefined>(undefined);
  public readonly descriptionChange: OutputEmitterRef<string> = output<string>();

  protected startEdit(): void {
    this.isEditing.set(true);
  }

  protected onSaved(newDescription: string): void {
    this.descriptionChange.emit(newDescription);
    this.isEditing.set(false);
  }
}
